import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import GreenFocus from './components/GreenFocus';
import HowItWorks from './components/HowItWorks';
import FutureServices from './components/FutureServices';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="font-sans">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <GreenFocus />
      <HowItWorks />
      <FutureServices />
      <Contact />
      <Footer />
    </main>
  );
}
